<template>
  <div class="fade-down w-full grid grid-cols-[1fr_1200px_1fr]">
    <div :class="dark ? 'bg-gray-70' : 'bg-gray-10'"></div>
    <div class="flex">
      <section
        :class="[
          'w-[163px] flex py-12',
          dark ? 'bg-gray-70 text-primary-40' : 'bg-gray-10 text-primary-50'
        ]"
      >
        <p class="heading-small items-center">{{ menuText }}</p>
      </section>

      <section
        :class="[
          ' flex-1 flex divide-x p-12 gap-12 hover:text-primary-50',
          dark ? 'bg-gray-80 divide-gray-70' : 'bg-gray-5 divide-gray-20'
        ]"
      >
        <article v-for="(items, index) in menuItems" :key="index">
          <ul v-if="items.children" class="w-90 grid gap-4">
            <p :class="['text-small-semibold', dark ? 'text-white' : 'text-gray-95']">
              {{ items.text }}
            </p>

            <li v-for="item in items.children" :key="item.key">
              <BtnText
                v-if="item.to"
                :label="item.text"
                size="lg"
                class="mb-2"
                bold="regular"
                :dark="dark"
                :active="currentLink === item.to"
                @click="moveTo(item.to, item.openInNewTab)"
              />
            </li>
          </ul>

          <div v-else class="w-90 h-full flex items-center">
            <BtnText
              v-if="items.to"
              :label="items.text"
              size="lg"
              bold="semibold"
              :dark="dark"
              :active="currentLink === items.to"
              @click="moveTo(items.to, items.openInNewTab)"
            />
          </div>
        </article>
      </section>
    </div>
    <div :class="dark ? 'bg-gray-80' : 'bg-gray-5'"></div>
  </div>
</template>

<script setup lang="ts">
import BtnText from '../button/BtnText.vue'
import { onMounted, ref, computed } from 'vue'
import {
  getMainLinks,
  getDeviceLinks,
  getDemoLinks,
  getProjectLinks,
  getAILinks,
  getUsecaseLinks
} from '@/app/router/navigation'

type Props = {
  menu: string
  currentLink: string
  dark?: boolean
}
const props = defineProps<Props>()
const emits = defineEmits(['moveRouter'])

const menuItems = computed((): RouteLink[] => {
  let result: RouteLink[] = []
  switch (props.menu) {
    case 'demo':
      result = getDemoLinks()
      break
    case 'devices':
      result = getDeviceLinks()
      break
    case 'projects':
      result = getProjectLinks()
      break
    case 'ai':
      result = getAILinks()
      break
    case 'usecase':
      result = getUsecaseLinks()
      break
    default:
      result = []
  }

  return result
})

const moveTo = (url: string, newTab?: boolean) => {
  if (newTab) {
    window.open(url, '_blank')
  } else {
    window.location.href = url
  }

  emits('moveRouter')
}

const menuText = computed(() => {
  const mainLinks = getMainLinks()
  return mainLinks.find((link) => link.key === props.menu)?.text || ''
})
</script>
